import script from "./JoinLinkInvalid.vue?vue&type=script&setup=true&lang=js"
export * from "./JoinLinkInvalid.vue?vue&type=script&setup=true&lang=js"

import "./JoinLinkInvalid.vue?vue&type=style&index=0&id=3b313870&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b313870"]])

export default __exports__